import {
  Box,
  Button,
  Collapse,
  Container,
  Divider,
  Menu,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import FelixAnalytics from "../../../../felixAnalytics";
import { useUsuario } from "../../../../providers/usuarioProvider";
import Usuario from "../../../../models/usuario";
import UsuarioDb from "../../../../db/usuarioDb";
import UploadInternacionalDb from "../../../../db/uploadInternacionalDb";
import {
  addDoc,
  getDocs,
  limit,
  onSnapshot,
  query,
  updateDoc,
} from "firebase/firestore";
import { IconChevronDown, IconRefresh } from "@tabler/icons-react";
import AlterarPontoDePartidaDialog from "./alterarPontoDePartidaDialog";
import AlterarPontoDePartidaInternacionalDialog from "./alterarPontoDePartidaInternacionalDialog";
import DesativarMercadoInternacionalDialog from "./desativarMercadoInternacionalDialog";
import CalculoDb from "../../../../db/calculoDb";
import Calculo from "../../../../models/calculo";
import moment from "moment-timezone";
import felixAnalytics from "../../../../felixAnalytics";
import { SituacaoCalculo } from "../../../../models/enum";
import RefazerCalculosDialog from "./refazerCalculosDialog";
import { useSnackBar } from "../../../../stores/snackBarStores";

export default function AbaPreferencias() {
  const { visualizado } = useUsuario();
  const dispatchSnack = useSnackBar();
  const [usuario, setUsuario] = useState<Usuario>();
  const [openAvancada, setOpenAvancada] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openPontoDePartida, setOpenPontoDePartida] = useState(false);
  const [openPontoDePartidaIntl, setOpenPontoDePartidaIntl] = useState(false);
  const [openRefazerCalculos, setOpenRefazerCalculos] = useState(false);
  const [openDesativarIntl, setOpenDesativarIntl] = useState(false);
  const [verificandoIntl, setVerificandoIntl] = useState(false);

  useEffect(() => {
    if (visualizado) {
      return onSnapshot(
        new UsuarioDb().doc({ usuarioId: visualizado }),
        (snapshot) => {
          setUsuario(snapshot.data());
        }
      );
    }
  }, [visualizado]);

  const handleChange = (field: string, value: boolean) => {
    if (!!visualizado) {
      FelixAnalytics.identify(visualizado);
      FelixAnalytics.track(field, { value });
      updateDoc(new UsuarioDb().doc({ usuarioId: visualizado }), {
        [`preferencias.${field}`]: value,
      }).catch((error) => {
        console.log(error);
        dispatchSnack({
          type: "ALERT",
          payload: {
            mensagem: "Não foi possível salvar. Tente novamente.",
            severidade: "error",
          },
        });
      });
    }
  };

  const handleMercadoInternacionalChange = async (value: boolean) => {
    if (!visualizado) return;
    if (value) {
      handleChange("mercadoInternacional", true);
      return;
    }
    setVerificandoIntl(true);
    try {
      const snapshot = await getDocs(
        query(
          new UploadInternacionalDb().collection({
            usuarioId: visualizado,
            uploadId: "",
          }),
          limit(1)
        )
      );
      if (snapshot.empty) {
        handleChange("mercadoInternacional", false);
      } else {
        setOpenDesativarIntl(true);
      }
    } catch (error) {
      console.log(error);
      // EC1 fail-safe: em caso de erro na verificação, abre o dialog por segurança
      setOpenDesativarIntl(true);
    } finally {
      setVerificandoIntl(false);
    }
  };

  return (
    <Container disableGutters>
      <Box pb={4}>
        {/* Section header numerado: NN em mono + nome na Mabry (DESIGN.md). */}
        <Box display="flex" alignItems="baseline" gap={1.5}>
          <Typography variant="eyebrow" color="text.secondary">
            01
          </Typography>
          <Typography variant="h3" color="text.primary">
            Cálculo
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" pt={0.5} pb={1}>
          Customize os cálculos de{" "}
          {!!usuario?.contaPai ? (
            <Typography
              variant="body2"
              color="text.primary"
              fontWeight={500}
              component="span"
            >
              {usuario.nome}
            </Typography>
          ) : (
            "acordo com seu perfil"
          )}
          .
        </Typography>
        <Divider />
        <Box display="flex" flexDirection="row" alignItems="flex-start" py={2}>
          <Box flexBasis="20%" flexGrow={1} flexShrink={0} pt={0.75}>
            <Typography variant="labelMono" component="p" color="text.primary">
              Venda a descoberto
            </Typography>
            {!!usuario?.preferencias?.vendaDescoberta && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ mt: 1.5 }}
                startIcon={<IconRefresh size={16} />}
                onClick={() =>
                  addDoc(
                    new CalculoDb().collection({
                      usuarioId: usuario.id,
                      calculoId: "",
                    }),
                    new Calculo({
                      id: "",
                      dataCalculo: moment.tz("America/Sao_Paulo"),
                      dataCriacao: moment.tz("America/Sao_Paulo"),
                      dataFim: moment.tz("America/Sao_Paulo").endOf("day"),
                      dataInicio: usuario.atualizadoAte,
                      dataProgresso: usuario.atualizadoAte,
                      situacao: SituacaoCalculo.CALCULANDO,
                    })
                  ).finally(() => {
                    felixAnalytics.identify(usuario.id);
                    felixAnalytics.track("calcular");
                  })
                }
              >
                Recalcular
              </Button>
            )}
          </Box>
          <Box
            flexBasis="80%"
            flexGrow={1}
            flexShrink={0}
            display="flex"
            flexDirection="row"
          >
            <Switch
              checked={!!usuario?.preferencias?.vendaDescoberta}
              onChange={(event) =>
                handleChange(event.target.name, event.target.checked)
              }
              name="vendaDescoberta"
              color="primary"
            />
            <Box px={1} />
            <Typography variant="body2" color="text.secondary">
              Venda a descoberto (ou short) é um operação de venda de uma
              quantidade maior do que a quantidade em custódia para um ativo.
              Não habilite caso não faça esse tipo de operação, assim podemos te
              ajudar a identificar caso alguma nota esteja faltando.
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box display="flex" flexDirection="row" alignItems="flex-start" py={2}>
          <Box flexBasis="20%" flexGrow={1} flexShrink={0} pt={0.75}>
            <Typography variant="labelMono" component="p" color="text.primary">
              Mercado internacional
            </Typography>
          </Box>
          <Box
            flexBasis="80%"
            flexGrow={1}
            flexShrink={0}
            display="flex"
            flexDirection="row"
          >
            <Switch
              checked={!!usuario?.preferencias?.mercadoInternacional}
              onChange={(event) =>
                handleMercadoInternacionalChange(event.target.checked)
              }
              disabled={verificandoIntl}
              name="mercadoInternacional"
              color="primary"
            />
            <Box px={1} />
            <Typography variant="body2" color="text.secondary">
              Habilite para calcular o IR dos investimentos no exterior
              conforme a Lei 14.754/2023. A leitura de notas e statements
              passa a aceitar operações em mercados internacionais. Você pode
              desativar a qualquer momento.
            </Typography>
          </Box>
        </Box>
        {openDesativarIntl && (
          <DesativarMercadoInternacionalDialog
            open={openDesativarIntl}
            onClose={() => setOpenDesativarIntl(false)}
            onConfirm={async () => {
              handleChange("mercadoInternacional", false);
              setOpenDesativarIntl(false);
            }}
          />
        )}
        <Divider />
      </Box>
      <Box pb={4}>
        <Box display="flex" alignItems="baseline" gap={1.5}>
          <Typography variant="eyebrow" color="text.secondary">
            02
          </Typography>
          <Typography variant="h3" color="text.primary">
            Notificações
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" pt={0.5} pb={1}>
          Personalize quais notificações deseja receber.
        </Typography>
        <Divider />
        <Box display="flex" flexDirection="row" alignItems="flex-start" py={2}>
          <Box flexBasis="20%" flexGrow={1} flexShrink={0} pt={0.75}>
            <Typography variant="labelMono" component="p" color="text.primary">
              Newsletter
            </Typography>
          </Box>
          <Box
            flexBasis="80%"
            flexGrow={1}
            flexShrink={0}
            display="flex"
            flexDirection="row"
          >
            <Switch
              checked={!!!usuario?.preferencias?.spam}
              onChange={(event) =>
                handleChange(event.target.name, !event.target.checked)
              }
              name="spam"
              color="primary"
            />
            <Box px={1} />
            <Typography variant="body2" color="text.secondary">
              A gente também não gosta de spam, então deixe habilitado para
              receber alguns e-mails com novidades, promoções e comunicados.
              Caso você não queira receber nenhum email, desabilite essa opção
              que a gente não te incomoda!
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box display="flex" flexDirection="row" alignItems="flex-start" py={2}>
          <Box flexBasis="20%" flexGrow={1} flexShrink={0} pt={0.75}>
            <Typography variant="labelMono" component="p" color="text.primary">
              Lembrete de cálculo
            </Typography>
          </Box>
          <Box
            flexBasis="80%"
            flexGrow={1}
            flexShrink={0}
            display="flex"
            flexDirection="row"
          >
            <Switch
              checked={!!usuario?.preferencias?.lembreteCalculo}
              onChange={(event) =>
                handleChange(event.target.name, event.target.checked)
              }
              name="lembreteCalculo"
              color="primary"
            />
            <Box px={1} />
            <Typography variant="body2" color="text.secondary">
              Não deixe pra última hora! Habilite essa opção que a gente te
              lembra de calcular seu mês antes do prazo final do pagamento da
              DARF.
            </Typography>
          </Box>
        </Box>
        <Divider />
      </Box>
      <Button variant="outlined" onClick={() => setOpenAvancada(true)}>
        Configurações avançadas
      </Button>
      <Collapse in={openAvancada}>
        <Box py={4}>
          <Box display="flex" alignItems="baseline" gap={1.5}>
            {/* Eyebrow em warn: a seção altera cálculo. Usa a TINTA de warn
                (`statusChip.warn.fg`), não `warning.main`: o laranja de
                preenchimento dá 3,61:1 sobre o papel claro e reprova nos
                4,5:1 de texto de 11px. */}
            <Typography
              variant="eyebrow"
              sx={(theme) => ({ color: theme.palette.statusChip.warn.fg })}
            >
              03
            </Typography>
            <Typography variant="h3" color="text.primary">
              Área de Atenção
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" pt={0.5} pb={1}>
            Essa área tem opções que vão afetar os cálculos. Só altere essas
            opções após ler cuidadosamente.
          </Typography>
          <Divider />
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            py={2}
          >
            <Box flexBasis="70%" flexGrow={1} flexShrink={0}>
              <Typography variant="h6" component="p" color="text.primary">
                Alterar ponto de partida
              </Typography>
              <Typography variant="body2" color="text.secondary">
                O ponto de partida é definido como o mês anterior à primeira
                nota inserida na plataforma. Caso você deseje iniciar os
                cálculos em um mês específico preenchendo o ponto de partida
                poderá fazê-lo por aqui. Mas atenção, ao alterar a data do ponto
                de partida todas as informações anteriores à nova data serão
                descartadas.
              </Typography>
            </Box>
            <Box
              flexBasis="30%"
              flexGrow={1}
              flexShrink={0}
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                onClick={() => setOpenPontoDePartida(true)}
              >
                Alterar ponto de partida
              </Button>
              {openPontoDePartida && (
                <AlterarPontoDePartidaDialog
                  open={openPontoDePartida}
                  onClose={() => setOpenPontoDePartida(false)}
                  usuarioId={visualizado ?? ""}
                />
              )}
            </Box>
          </Box>
          <Divider />
          {/* Só faz sentido com o mercado internacional ligado: o ponto de
              partida internacional é independente do nacional. */}
          {!!usuario?.preferencias?.mercadoInternacional && (
            <>
              <Box
                display="flex"
                flexDirection="row"
                alignItems="flex-start"
                py={2}
              >
                <Box flexBasis="70%" flexGrow={1} flexShrink={0}>
                  <Typography variant="h6" component="p" color="text.primary">
                    Alterar ponto de partida internacional
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    O ponto de partida internacional é a data da custódia
                    inicial dos seus ativos no exterior
                    {!!usuario?.pontoDePartidaInternacional && (
                      <>
                        {" "}
                        (hoje em{" "}
                        <Typography
                          component="span"
                          variant="dataMono"
                          sx={{ fontSize: "inherit" }}
                        >
                          {usuario.pontoDePartidaInternacional
                            .clone()
                            .tz("America/Sao_Paulo")
                            .format("DD/MM/YYYY")}
                        </Typography>
                        )
                      </>
                    )}
                    . Para editar a custódia ou o prejuízo acumulado nessa data,
                    use a aba Ponto de Partida no Mercado Internacional. Use
                    esta opção só para mudar a data: a custódia inicial e todos
                    os meses internacionais calculados serão descartados, e os
                    statements importados são mantidos.
                  </Typography>
                </Box>
                <Box
                  flexBasis="30%"
                  flexGrow={1}
                  flexShrink={0}
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                >
                  <Button
                    variant="contained"
                    onClick={() => setOpenPontoDePartidaIntl(true)}
                  >
                    Alterar ponto de partida internacional
                  </Button>
                  {openPontoDePartidaIntl && (
                    <AlterarPontoDePartidaInternacionalDialog
                      open={openPontoDePartidaIntl}
                      onClose={() => setOpenPontoDePartidaIntl(false)}
                      usuarioId={visualizado ?? ""}
                    />
                  )}
                </Box>
              </Box>
              <Divider />
            </>
          )}
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            py={2}
          >
            <Box flexBasis="70%" flexGrow={1} flexShrink={0}>
              <Typography variant="h6" component="p" color="text.primary">
                Refazer cálculos
              </Typography>
              <Typography variant="body2" color="text.secondary">
                A Felix possui uma tecnologia que garante que toda informação
                nova incluída na plataforma é levada em conta no próximo cálculo
                realizado. Contudo, caso deseje refazer o cálculo de algum
                período pode fazer por aqui.
              </Typography>
            </Box>
            <Box
              flexBasis="30%"
              flexGrow={1}
              flexShrink={0}
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                onClick={() => setOpenRefazerCalculos(true)}
              >
                Refazer cálculos
              </Button>
              {openRefazerCalculos && (
                <RefazerCalculosDialog
                  open={openRefazerCalculos}
                  onClose={() => setOpenRefazerCalculos(false)}
                  usuarioId={visualizado ?? ""}
                />
              )}
            </Box>
          </Box>
          <Divider />
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            py={2}
          >
            <Box flexBasis="70%" flexGrow={1} flexShrink={0}>
              <Typography variant="h6" component="p" color="text.primary">
                Comportamento ao ler operações incompatíveis
              </Typography>
              <Typography variant="body2" color="text.secondary">
                A leitura de notas é interrompida ao ler operações de ativos e
                mercados que ainda não somos compatíveis. Escolha ignorar e
                prosseguir com a leitura caso tenha confiança para completar os
                cálculos desses ativos e mercados à parte por conta própria.
              </Typography>
            </Box>
            <Box
              flexBasis="30%"
              flexGrow={1}
              flexShrink={0}
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
            >
              <Button
                variant="contained"
                color="primary"
                endIcon={<IconChevronDown />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
              >
                {!!usuario?.preferencias.incompatibilidades
                  ? "Ignorar e prosseguir"
                  : "Interromper leitura"}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem
                  selected={!!usuario?.preferencias.incompatibilidades}
                  onClick={() => {
                    handleChange("incompatibilidades", true);
                    setAnchorEl(null);
                  }}
                >
                  <Typography variant="body2">Ignorar e prosseguir</Typography>
                </MenuItem>
                <MenuItem
                  selected={!!!usuario?.preferencias.incompatibilidades}
                  onClick={() => {
                    handleChange("incompatibilidades", false);
                    setAnchorEl(null);
                  }}
                >
                  <Typography variant="body2">Interromper leitura</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
          <Divider />
        </Box>
      </Collapse>
    </Container>
  );
}
